"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = filterUserFlowResults;
const accessibility_standards_1 = __importDefault(require("@deque/accessibility-standards"));
const filter_extension_issues_1 = require("./filter-extension-issues");
/**
 * filter user flow results based on passed filters, returns filtered results and counts. Counts that are not possible to calculate are set to -1
 */
function filterUserFlowResults(ufaResults, filters) {
    const filteredPageStateResults = ufaResults.pageStateResults.map(fullResult => ({
        ...fullResult,
        result: filterDedupedResults(fullResult.result, filters)
    }));
    const filteredTotalResults = filterDedupedResults(ufaResults.results, filters);
    let currUniqueIssues = 0;
    let newIssues = 0;
    let bestPractices = 0;
    const baseSeverityCount = {
        totalCurrent: 0
    };
    const numIssueSeverity = {
        critical: { ...baseSeverityCount },
        serious: { ...baseSeverityCount },
        moderate: { ...baseSeverityCount },
        minor: { ...baseSeverityCount }
    };
    for (const result of filteredTotalResults) {
        const impact = result.impact;
        const nodeCount = result.uniques.length;
        newIssues += result.uniques.filter(unique => unique.isNewIssue).length;
        numIssueSeverity[impact].totalCurrent += nodeCount;
        currUniqueIssues += nodeCount;
        if ((0, filter_extension_issues_1.isBestPracticeIssue)({ tags: result.tags, rule: result.id }, { accessibilityStandard: filters.configAccessibilityStandard })) {
            bestPractices += nodeCount;
        }
    }
    const overview = {
        currUniqueIssues,
        newIssues,
        numIssueSeverity,
        bestPractices
    };
    return {
        overview,
        pageStateResults: filteredPageStateResults,
        results: filteredTotalResults
    };
}
const filterDedupedResults = (watcherResults, filters) => {
    const filteredResults = [];
    watcherResults.forEach(result => {
        const isIssueBestPractice = (0, filter_extension_issues_1.isBestPracticeIssue)({ tags: result.tags, rule: result.id }, { accessibilityStandard: filters.configAccessibilityStandard });
        // Base Filters
        // Do not include best practice issue if best practices are disabled
        if (filters.configBestPractices === 'disabled' && isIssueBestPractice) {
            return;
        }
        const issueMatchesRuleset = filters.configAccessibilityStandard === 'all' ||
            result.tags?.find(tag => accessibility_standards_1.default[filters.configAccessibilityStandard].tags.includes(tag));
        // If not a best practice issue AND the issue's tags don't include the applied standard/ruleset, exclude the issue
        if (!isIssueBestPractice && !issueMatchesRuleset) {
            return;
        }
        // If page state key filter is provided, we need to include issues only related to this page state
        if (filters.pageStateKey && result.pageStateId !== filters.pageStateKey) {
            return;
        }
        // Other Filters
        const addResult = () => {
            filteredResults.push(result);
        };
        if (filters.impact.includes(result.impact)) {
            addResult();
            return;
        }
        if (filters.bestPractices && isIssueBestPractice) {
            addResult();
            return;
        }
        // all user flow issues are automatic
        if (filters.automatic) {
            addResult();
            return;
        }
    });
    return filteredResults;
};
//# sourceMappingURL=filter-user-flow-results.js.map